import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {toast} from "react-toastify"
import {ERROR_MSG, http_no_auth, REFRESH_TOKEN, ROLE, TOKEN, USER_DATA} from "../../utility/Utils"
import {useHistory} from "react-router-dom"

export const loadUser = createAsyncThunk('app/getProfile', async () => {

    const {push} = useHistory()

    const token = localStorage.getItem(TOKEN) || ""
    const user_data = localStorage.getItem(USER_DATA)

    if (!token || !user_data) {
        push("/login")
    }
})

export const login = createAsyncThunk('app/Login', async (data) => {
    const response = await http_no_auth.post('/oauth/v1/oauth/login', data)
    return response.data
})

export const enterONEID = createAsyncThunk('app/ONE_ID', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/oauth/v1/id-egov-uz/login', data)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})
export const signUp = createAsyncThunk('app/ONE_ID', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('oauth/v1/oauth/logout', data)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})
export const ssoLogin = createAsyncThunk('app/ONE_ID', async (data, {rejectWithValue}) => {
    try {
        const response = await http_no_auth.post('/oauth/v1/sso/login', data)
        return response.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const handleRefreshLogin = createAsyncThunk('authenticate/handleRefreshLogin', async (data, {
    rejectWithValue
}) => {
    try {
        const response = await http_no_auth.post('/oauth/v1/oauth/refresh-token', data)
        if (response.data?.error_code === 401) {
            localStorage.removeItem(USER_DATA)
            localStorage.removeItem(TOKEN)
            localStorage.removeItem(ROLE)
            window.location.replace("/login")
        }
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        return rejectWithValue(error.message)
    }
})

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        userData: {},
        idEguMsg: '',
        isAuth: false,
        authModal: false,
        isLoading: false,
        accessToken: localStorage.getItem(TOKEN) || ""
    },
    reducers: {
        handleLogout: state => {
            state.userData = {}
            state.accessToken = ''
            state.isAuth = false
            localStorage.removeItem(USER_DATA)
            localStorage.setItem(TOKEN, "")
            localStorage.removeItem(ROLE)
        }
    },
    extraReducers: {
        [login.fulfilled]: (state, action) => {
            if (action.payload?.status === 403) {
                return toast.error(action.payload?.message)
            } else {
                state.accessToken = action?.payload?.data?.access_token
                state.isLoading = false
                localStorage.setItem(TOKEN, action.payload.data?.access_token ? action.payload.data?.access_token : null)
                localStorage.setItem(REFRESH_TOKEN, action.payload.data?.refresh_token)
                localStorage.setItem(USER_DATA, JSON.stringify(action.payload.data?.user_info))
                state.authModal = false
            }
        },
        [signUp.fulfilled]: (state) => {
            state.isLoading = false

        },
        [ssoLogin.fulfilled]: (state, action) => {
            if (action.payload?.status === 403) {
                return toast.error(action.payload?.message)
            } else {
                state.accessToken = action?.payload?.data?.access_token
                localStorage.setItem(TOKEN, action.payload.data?.access_token)
                localStorage.setItem(REFRESH_TOKEN, action.payload.data?.refresh_token)
                localStorage.setItem(USER_DATA, JSON.stringify(action.payload.data?.user_info))
            }
        },
        [ssoLogin.rejected]: (state, action) => {
            state.isLoading = false
            toast.error(action.payload)
        },
        [login.pending]: (state) => {
            state.isLoading = true
        },
        [login.rejected]: (state, action) => {
            state.isLoading = false
            toast.error(action.payload)
        },
        [loadUser.fulfilled]: (state, action) => {
            state.userData = action?.payload?.user
            state.isAuth = action?.payload?.isAuth
            localStorage.setItem('userData', JSON.stringify(action.payload))
        },
        [loadUser.rejected]: (state) => {
            state.isAuth = false
            localStorage.removeItem('userData')
            localStorage.removeItem('access_Token')
        },

        [handleRefreshLogin.fulfilled]: (state, actions) => {
            const errorAuth = actions.payload?.status
            localStorage.setItem(TOKEN, actions.payload?.access_token)
            localStorage.setItem(REFRESH_TOKEN, actions.payload?.refresh_token)
            localStorage.setItem(USER_DATA, JSON.stringify(actions.payload?.user_info))
            window.location.reload(false)
            if (errorAuth === 401) state.authModal = true
            state.isLoading = false
        },
        [handleRefreshLogin.pending]: (state) => {
            state.isLoading = true
        },
        [handleRefreshLogin.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },

        [enterONEID.fulfilled]: (state, action) => {
            if (action.payload.status === 403) {
                state.idEguMsg = action.payload.message
            } else if (action.payload.status === 401) {
                toast.error(action.payload.message)
                localStorage.clear()
            } else {
                if (action?.payload?.data?.access_token) {
                state.accessToken = action?.payload?.data?.access_token
                state.isLoading = false
                localStorage.setItem(TOKEN, action.payload.data?.access_token)
                localStorage.setItem(REFRESH_TOKEN, action.payload.data?.refresh_token)
                localStorage.setItem(USER_DATA, JSON.stringify(action.payload.data?.user_info))
                }
            }
            state.isLoading = false
        },
        [enterONEID.pending]: (state) => {
            state.isLoading = true
        },
        [enterONEID.rejected]: (state) => {
            toast.error(ERROR_MSG)
            state.isLoading = false
        }
    }
})

export const {handleLogout} = authSlice.actions

export default authSlice.reducer
